import React from 'react';
import { Switch, Route, Redirect, useLocation, useRouteMatch } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Booking from './pages/Booking';
import RegisterSuccess from './pages/RegisterSuccess';
import Dashboard from './pages/Dashboard';
import AnnotationTool from './pages/AnnotationTool/AnnotationToolContainer';
import RequestAnalysis from './pages/RequestAnalysis/ClientFormContainer';
import Index from './pages/Index';
import ComoFotografarIris from './pages/Others/como-fotografar-iris.js';
import Analysis from './pages/Analysis/Analysis.jsx';
import AnalysisReport from './pages/AnalysisReport/AnalysisReport.jsx';
import Quiz from './pages/Quiz';

const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  return parts[0]
};

export default function AppRoutes() {
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const subdomain = getSubdomain();

  // Garante que não tenhamos barras duplas se o path for apenas "/"
  const base = path === '/' ? '' : path;

  if (subdomain === 'analysis') {
    return (
      <Switch>
        <Route path={`${path}`} exact component={Analysis} />
        <Route path={`${base}/annotation-tool/:idCall`} component={AnnotationTool} />
        <Route path={`${base}/request-analysis`} component={RequestAnalysis} />
        <Route path={`${base}/analysis-report/:idCall`} component={AnalysisReport} />
        <Route path={`${base}/how-to-photograph-your-iris`} exact component={ComoFotografarIris} />
        <Route path={`${base}/descubra-seu-perfil/:leadId?`} exact component={Quiz} />
        <Route path={`${base}/login`} exact component={Login} />
        <Route path={`${base}/dashboard`} component={Dashboard} />
        <Redirect to={{ pathname: `${url}`, search: location.search }} />
      </Switch>
    )
  } else {
    return (
      <Switch>
        <Route path={`${path}`} exact component={Index} />
        <Route path={`${base}/login`} exact component={Login} />
        <Route path={`${base}/dashboard`} component={Dashboard} />
        <Route path={`${base}/booking`} component={Booking} />
        <Route path={`${base}/annotation-tool/:idCall`} component={AnnotationTool} />
        <Route path={`${base}/request-analysis`} component={RequestAnalysis} />
        <Route path={`${base}/analysis-report/:idCall`} component={AnalysisReport} />
        <Route path={`${base}/how-to-photograph-your-iris`} exact component={ComoFotografarIris} />
        <Route path={`${base}/descubra-seu-perfil/:leadId?`} exact component={Quiz} />
        {/*<Route path="/register" exact component={Register} />*/}
        <Route path={`${base}/register-success`} exact component={RegisterSuccess} />
        <Redirect to={{ pathname: `${url}`, search: location.search }} />
      </Switch>
    );
  }
}